import { createFileRoute, redirect } from '@tanstack/react-router';
import { trpcVanilla } from '@/client/utils/trpc-client';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/client/components/ui/card';

export const Route = createFileRoute('/_app/analytics')({
  beforeLoad: async () => {
    const me = await trpcVanilla.user.me.query();
    if (me.role !== 'ADMIN') throw redirect({ to: '/' });
  },
  component: AnalyticsPage,
});

function AnalyticsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Analytics</h1>
        <p className="text-muted-foreground">Track your key metrics.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Overview</CardTitle>
          <CardDescription>Connect your analytics provider to display charts.</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Analytics coming soon.</p>
        </CardContent>
      </Card>
    </div>
  );
}
